<div class="post-booking">
  <p class="post-booking__nudge">
    Feel free to come back to the agent if you need to change the time, cancel, or update the objective.
  </p>
  @if (!answer) {
    <p class="post-booking__question">Do you need to book additional meetings?</p>
    <div class="post-booking__actions">
      <button type="button" class="post-booking__btn post-booking__btn--yes"
        [disabled]="disabled" (click)="onYes()">
        <i class="pi pi-check" aria-hidden="true"></i> Yes
      </button>
      <button type="button" class="post-booking__btn post-booking__btn--no"
        [disabled]="disabled" (click)="onNo()">
        <i class="pi pi-times" aria-hidden="true"></i> No
      </button>
    </div>
  }
  @if (answer === 'no') {
    <p class="post-booking__response">
      <i class="pi pi-check-circle" aria-hidden="true"></i>
      You are all set — good luck!
    </p>
  }
</div>
